import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Login from './components/auth/Login';
import NuevaCuenta from './components/auth/NuevaCuenta';
import Proyectos from './components/proyectos/Proyectos';
import ProyectoState from './context/proyectos/ProyectoState';
import TareaState from './context/tareas/tareaState';
import AlertaState from './context/alertas/AlertaState';
import AuthState from './context/autenticacion/authState';
import tokenAuth from './config/tokenAuth';
import RutaPrivada from './components/rutas/RutaPrivada'; //higher order components

//revisar si tenemos un token
const token =localStorage.getItem('token');
if(token){
  tokenAuth(token)
}
function App() {
  //usamos nuestra variable de entorno, para que la refleje a veces hay que detener la consola y volverla a correr con npm start
  /* console.log(process.env.REACT_APP_BACKEND_URL); */
  return (
   
    <ProyectoState>
      <TareaState>
        <AlertaState>
          <AuthState>
          <Router>
            <Switch>
              <Route exact path="/" component={Login}/>
              <Route exact path="/nueva-cuenta" component={NuevaCuenta}/>
              <RutaPrivada exact path="/proyectos" component={Proyectos}/>
              {/* <Route exact path="/proyectos" component={Proyectos}/> */} {/* hacemos esto despues que hacemos que las rutas sean privadas */}
            </Switch>
          </Router>
          </AuthState>
        </AlertaState>
      </TareaState>
    </ProyectoState>
    
  );
}

export default App;
